import { Injectable } from '@angular/core';
import { StripeUtil } from '../../../../../../common/src/utils/stripe.util';
import { environment } from '../../environments/environment';

@Injectable()
export class StripeManager {
  getPublishableKey(ownersEmail: string): any {
    if (StripeUtil.shouldUseTestCredentials(ownersEmail)) {
      return environment.stripe.publishableKeyTest;
    }

    return environment.stripe.publishableKey;
  }
}
